import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";

/** Toasts the result of the Google Drive OAuth round-trip (`/studio?drive=…`) and cleans the URL. */
export default function useDriveCallbackToast() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const result = params.get("drive");
    if (!result) return;
    if (result === "connected") {
      toast.success("Google Drive connected", {
        description: "New songs now auto-save to your 'ELPM Studio' folder. Toggle it any time in My Songs.",
        duration: 7000,
      });
    } else {
      toast.error("Google Drive connection failed", {
        description: "The Google sign-in was cancelled or the app isn't authorised yet. Try again from My Songs.",
      });
    }
    params.delete("drive");
    navigate({ pathname: location.pathname, search: params.toString() ? `?${params}` : "" }, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);
}
